/*
 * Copyright (c) 2020 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import MockAdapter from 'axios-mock-adapter';
import { BaseFeatureMock } from '../mockServer/featureMock';
import { ReportSearchFilterType, ReportsListDto, ReportsQueryParams } from './reportsClient.typings';
import { reportsByDayDtoFactory, reportsDtoFactory } from './reportsFactories';

const REPORTS_URL = /\/reports\/cashBox$/;
const REPORTS_BY_DAY_URL = /\/reports\/cashBoxDay$/;

type ReportsRequestBody = Omit<ReportsQueryParams, 'search_type' | 'search_text'> &
    Partial<Record<ReportSearchFilterType, string[]>>;

class ReportsFeatureMock extends BaseFeatureMock {
    public readonly listReports = this.route<ReportsListDto, ReportsRequestBody>({
        method: 'post',
        url: REPORTS_URL,
        defaultResponse: (config) => {
            const body: ReportsRequestBody = JSON.parse(config.data);
            const data: ReportsListDto = {
                afterKey: 'last_cashBox_taxNumber',
                reports: reportsDtoFactory.list({ count: body.limit }),
            };

            return [200, data];
        },
        delayMs: 500,
    });

    public readonly listReportsByDay = this.route<ReportsListDto, ReportsRequestBody>({
        method: 'post',
        url: REPORTS_BY_DAY_URL,
        defaultResponse: (config) => {
            const body: ReportsRequestBody = JSON.parse(config.data);
            const data: ReportsListDto = {
                afterKey: 'last_cashBox_taxNumber',
                reports: reportsByDayDtoFactory.list({ count: body.limit }),
            };

            return [200, data];
        },
        delayMs: 500,
    });

    protected onReset(): void {
        reportsDtoFactory.resetCount();
        reportsByDayDtoFactory.resetCount();
    }
}

export const reportsMock = new ReportsFeatureMock();

/** Backward-compat shims - dev mock mode (mockAdapter.ts) keeps calling these untouched. */
export function addReportsMockApi(mockAdapter: MockAdapter): void {
    reportsMock.listReports.attach(mockAdapter, { delay: true });
}

export function addReportsByDayMockApi(mockAdapter: MockAdapter): void {
    reportsMock.listReportsByDay.attach(mockAdapter, { delay: true });
}
